import { Routes, RouterModule } from '@angular/router';
import { EmployeeDetailsComponent } from './employee-details.component';

const routes: Routes = [ 
    { path: ':employeeName', component: EmployeeDetailsComponent },
    { path: 'new', component: EmployeeDetailsComponent }
];

export const EmployeeDetailsRouting = RouterModule.forChild(routes);
